import React from 'react'
import PropTypes from "prop-types";
// //import _ from "lodash";
// import Head from 'next/head';
import Slider from 'react-slick';

export default function TestimonialsSlice(props) {

	const {
		testimonials
	} = props;

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1920,
				settings: {
					slidesToShow: 3,
					infinite: false
				}
			},
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: 3,
					infinite: false
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					infinite: false,
					dots: false
				}
			}
		]
	};

	return (
		<React.Fragment>
		
				<link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
				<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
			
			<section className="testimonials-carousel">
				<div className="container-fluid">
					<div className="row">
						<div className="col-xs- 12">
							<h2 className="h2 title">What people are saying</h2>
							<div className="testimonials__list">
								<Slider {...settings}>
									{
										testimonials.map((testimonial, index) => (
											<div className="testimonials__list-item" key={index}>
												<div className="item">
													<p className="p-tag item__description">{testimonial.description}</p>
													<div className="details">
														<div className="details__image">
															<img className="image" src={testimonial.image} alt={testimonial.image_alternative} />
														</div>
														<div className="details__user">
															<h5 className="h5 name">{testimonial.name}</h5>
															<p className="p-tag title">{testimonial.company}</p>
														</div>
													</div>
												</div>
											</div>
										))
									}
								</Slider>
							</div>
						</div>
					</div>
				</div>
			</section>
		</React.Fragment>
	);
};

TestimonialsSlice.propTypes = {
	testimonials: PropTypes.arrayOf(
		PropTypes.shape({
			company: PropTypes.string,
			description: PropTypes.string,
			image: PropTypes.string,
			image_alternative: PropTypes.string,
			name: PropTypes.string
		})
	)
};



// WEBPACK FOOTER //
// src/client/components/slices/TestimonialsSlice.js